import { useMemo } from "react";
import { useRestaurant } from "@/hooks/use-restaurant";
import {
  resolveTenantBranding,
  type ResolvedTenantBranding,
} from "@/theme/resolve-tenant-branding";

export type TenantBranding = ResolvedTenantBranding;

/**
 * Resolved restaurant branding for chrome, tenant CTAs, selection, and surface tokens.
 * While restaurant config is not ready, all raw colors are ignored (no A→B leak).
 * Does not read Redux, cart, payment, or browser storage.
 */
export function useTenantBranding(): TenantBranding {
  const restaurant = useRestaurant();
  const theme_color = restaurant.isReady ? restaurant.theme_color : null;
  const primary_button_color = restaurant.isReady
    ? restaurant.primary_button_color
    : null;
  const secondary_button_color = restaurant.isReady
    ? restaurant.secondary_button_color
    : null;

  return useMemo(
    () =>
      resolveTenantBranding({
        theme_color,
        primary_button_color,
        secondary_button_color,
      }),
    [theme_color, primary_button_color, secondary_button_color],
  );
}
